import { apiClient } from "./client";

export const listLeads = (params = {}) =>
  apiClient.get("/leads/", { params }).then((r) => r.data);

export const downloadLeadsCsv = (params = {}) =>
  apiClient.get("/leads/download", { params, responseType: "blob" });

export const captureLeadGoogleMap = (leadId, imageFile) => {
  const formData = new FormData();
  formData.append("image", imageFile);
  return apiClient.post(
    `/leads/probate-divorce-integration/capture-google-map/${leadId}/`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  ).then((r) => r.data);
};
